export default __webpack_public_path__ + "static/media/v fetch.0d5a3cb4.png";